export default {
  codigo: 'Código',
  comissao: {
    listagem: {
      codigo: 'Código',
      ato: 'Ato',
      dataLei: 'Data da lei',
      dataValidade: 'Data de validade',
      tipo: 'Tipo comissão'
    },
    formulario: {
      membros: {
        codigo: 'Código',
        nome: 'Nome',
        cargo: 'Cargo'
      }
    }
  },

  descarte: {
    listagem: {
      numero: 'Número',
      modalidade: 'Modalidade',
      ato: 'Ato',
      dataLei: 'Data da Lei',
      data: 'Data',
      motivo: 'Motivo'
    }
  }
};
